import React, { useEffect, useState } from "react"
import { Form, Modal, Select } from "antd"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import api from "./store/api"
import { useTranslation } from "react-i18next"
import {setFormErrors} from "../../../helpers/formErrors";
import CustomInputNumber from "../../../components/CustomInputNumber"
import CustomSelect from "../../../components/CustomSelect"

const TariffRateChangeForm = ({ visible, setVisible, setRecord, record, changed, months }) => {
	const [loading, setLoading] = useState(false)
	const {t} = useTranslation(['common', 'valid', 'action'])
	const [form] = Form.useForm()

	const create = params => {
		action(api.create, params, changed, t('action:created'))
	}
	const update = params => {
		action(api.update, params, changed, t('action:updated'))
	}

	const action = (func, params, sucFunction, sucParams) => {
		setLoading(true)
		func(params)
			.then(res => sucFunction(res, sucParams))
			.catch(err => {
				setFormErrors(err, form)
			})
			.finally(() => setLoading(false))
	}

	useEffect(() => {
		form.resetFields()
		if (record) {
			form.setFieldsValue({
				year   : record.year,
				month  : record.month,
				value  : record.value,
               	})
		}
	}, [record])

	function handleCancel(){
		form.resetFields()
		setRecord(null)
		setVisible(false)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id         : record?.id,
				year       : values.year,
				month      : values.month,
				value      : values.value,
				createDate : record?.createDate,
              	isDeleted  : record?.isDeleted
			}
			const previousValues = {
				id         : record?.id,
				year       : record?.year,
				month      : record?.month,
				value      : record?.value,
				createDate : record?.createDate,
				isDeleted  : record?.isDeleted
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice(t('valid:sameData'), null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnHidden
			footer={[
				<CustomButton
					key="save"
					loading={loading}
					type="green"
					onClick={save}
				>
					{t('action:save')}
				</CustomButton>
			]}
			title={record ? t('action:editRecord') : t('action:addRecord')}
			open={visible}
			width={900}
			onCancel={handleCancel}
			>
			<Form
				form={form}
				labelAlign="left"
				labelCol={{span: 6}}
				name="nsi-form"
				wrapperCol={{span: 17, offset: 1}}
				>
				<Form.Item
					label={t('common:year')}
					name="year"
					>
					<CustomInput
						disabled={record}
						placeholder={`${t('action:enter')} ${t('common:year').toLowerCase()}`}
						/>
				</Form.Item>
				<Form.Item
					label={t('common:month')}
					name="month"
					>
					<CustomSelect
						allowClear
						showSearch
						disabled={record}
						filterOption={false}
						notFoundContent={null}
						placeholder={`${t('action:choose')} ${t('common:month').toLowerCase()}`}
						>
					 {months.map((item, i) => {
						 return (
							 <Select.Option
							 key={i + 1}
								 value={i + 1}
							 >
								 {t(`common:${item}`)}
							 </Select.Option>)
					 })}
				 </CustomSelect>
				</Form.Item>
				<Form.Item
					label={t('common:value')}
					name="value"
				>
					<CustomInputNumber
						min={0}
						placeholder={`${t('action:enter')} ${t('common:value').toLowerCase()}`}
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default TariffRateChangeForm